/*eslint complexity: ["error", 43]*/
/*eslint max-lines-per-function: ["error", 260]*/
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { FormRow66 } from '../../../app/components/FormRow';
import { CreateUpdateHealthcareFacilityDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface OpenCloseTimeEditorProps {
  healthcareFacility: CreateUpdateHealthcareFacilityDto;
  propertyChange: (obj: Partial<CreateUpdateHealthcareFacilityDto>) => void;
}

export const OpenCloseTimeEditor: React.FC<
  OpenCloseTimeEditorProps
> = props => {
  return (
    <>
      <Row>
        <Col md={6}>
          <FormRow66
            controlId="openTime1"
            label="Godzina otwarcia w poniedziałek"
          >
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.openMondayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  openMondayTime: e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="closeTime1"
            label="Godzina zamknięcia w poniedziałek"
          >
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.closeMondayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  closeMondayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormRow66 controlId="openTime2" label="Godzina otwarcia we wtorek">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.openTuesdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  openTuesdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="closeTime2"
            label="Godzina zamknięcia we wtorek"
          >
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.closeTuesdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  closeTuesdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="openTime3" label="Godzina otwarcia w środę">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.openWednesdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  openWednesdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66 controlId="closeTime3" label="Godzina zamknięcia w środę">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.closeWednesdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  closeWednesdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="openTime4" label="Godzina otwarcia w czwartek">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.openThursdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  openThursdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="closeTime4"
            label="Godzina zamknięcia w czwartek"
          >
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.closeThursdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  closeThursdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="openTime5" label="Godzina otwarcia w piątek">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.openFridayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  openFridayTime: e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66 controlId="closeTime5" label="Godzina zamknięcia w piątek">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.closeFridayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  closeFridayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="openTime6" label="Godzina otwarcia w sobotę">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.openSaturdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  openSaturdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66 controlId="closeTime6" label="Godzina zamknięcia w sobotę">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.closeSaturdayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  closeSaturdayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="openTime7" label="Godzina otwarcia w niedzielę">
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.openSundayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  openSundayTime: e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="closeTime7"
            label="Godzina zamknięcia w niedzielę"
          >
            <Form.Control
              type="time"
              value={
                props.healthcareFacility?.closeSundayTime?.slice(0, 5) || ''
              }
              onChange={e =>
                props.propertyChange({
                  closeSundayTime:
                    e.target.value === '' ? null : e.target.value,
                })
              }
            />
          </FormRow66>
        </Col>
      </Row>
    </>
  );
};
